import create from 'zustand';
import { persist } from "zustand/middleware";
import mixpanel from 'mixpanel-browser';

mixpanel.init('852777b33af7fd283e609250a1887e40', { debug: true })

export const useMixpanel = create(
  persist(
    () => ({

      track: (event, properties) => {
        try {
          return mixpanel.track(event, properties);
        } catch (error) {
         console.log(error);
        }
      },

      identify: (identifier) => {
        try {
          return mixpanel.identify(identifier);
        } catch (error) {
          console.log(error);
        }
      }
    }),
    {
      name: 'mixpanel',
      getStorage: () => localStorage,
    }
  )
);
